import { CircularProgress, Collapse, Container, Grid, IconButton, Radio, Slider } from "@mui/material";
import Header from "components/CloseFiscalYear/Header";
import BasicButton from "components/BasicInputs/BasicButton";
import PageHeader from "components/Shared/PageHeader";
import Tabs from "components/Tabs";
import Card from "./Card";
import useSubscription from "./data";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import PlusIcon from "assets/icons/PlusIcon";
import TrashIcon from "assets/icons/TrashIcon";
import MinusIcon from "assets/icons/MinusIcon";
import BillIcon from "assets/icons/BillIcon";
import Table from "components/Table2";
import ShopCart from "assets/icons/ShopCartIcon";
import StickyBox from "react-sticky-box";
import ContainedTabs from "components/Tabs/Tabs3";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setBusiness } from "../../../store/actions/businessAction";
import { useNavigate } from "react-router-dom";
import Main from "./chortkeShop/Main";
import Side from "./chortkeShop/Side";
import useResponsive from "helpers/useResponsive";
import RangeTab, { RangeTabLabel } from "./RangeTab";
import InfinityIcon from "assets/icons/InfinityIcon";
import PointArrow from "assets/icons/Plans/PointArrow.svg";
import Switch from "./Switch";
import { appSetFiscalYear, appSetFiscalYears } from "../../../store/actions/appAction";

export default function Subscription() {
  const data = useSubscription();
  const { subscriptions, subscription, handleSubmit, checkCoupon, state, tabs2 } = data;
  const { setState, durations, active, setActive, initialCoupon, diff, current } = data;
  const { table, topTabs } = data;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isMobile, isDesktop } = useResponsive();

  useEffect(() => {
    if (!subscription) {
      const suggested = subscriptions.find(
        (x) => x.offline === state.offline && x.durationTab === active.tabs2 && x.suggested
      );
      if (suggested) {
        setActive((x) => ({ ...x, subscription: suggested }));
      }
    }
  }, [subscriptions]);

  function Badge(props: { val: string | number; active?: boolean }) {
    const { val, active } = props;
    return (
      <div
        dir="ltr"
        className="absolute -top-2 -left-2 flex gap-1 justify-center items-center rounded py-0.5 px-2 bg-yellow-2 text-yellow-1"
      >
        <span>-{val}</span>
        <span>%</span>
      </div>
    );
  }

  return (
    <Container maxWidth="xl" className="px-1 md:px-10">
      <div className="my-4 md:my-12">
        <PageHeader
          heading="صورت حساب"
          subHeading="تمدید یا خرید اشتراک"
          backBtnTitle="بازگشت"
          backAction={() => {
            dispatch(setBusiness(null));
            dispatch(appSetFiscalYears([]));
            dispatch(appSetFiscalYear(null));
            navigate("/");
          }}
        />
      </div>

      <Grid container>
        {/* Main */}
        <Grid item md={8} xs={12} className="md:p-1 lg:p-2 select-none">
          <div className="bg-white rounded-lg">
            <Tabs {...topTabs} />

            {active.topTabs === 0 && (
              <>
                <div className="px-4 py-4 w-full flex flex-col">
                  {/* <div className="p-4">انتخاب محصول:</div> */}
                  {/* <ContainedTabs {...tabs1} size={1} styles={{ tab: { minWidth: "50%" } }} centered /> */}
                </div>
                {/* {active.tabs1 === 0 && ( */}
                <div className="p-2 md:p-4 lg:py-8 lg:px-14 flex flex-col justify-between flex-wrap items-center">
                  {/* <div className=" flex flex-col items-center justify-center w-full"> */}
                  {/*<span className="text-dark-3 w-full text-right">بازه زمانی اشتراک:</span>*/}
                  {/*<div className="px-6 w-full">*/}
                  {/*  <RangeTab*/}
                  {/*    step={1}*/}
                  {/*    min={0}*/}
                  {/*    max={3}*/}
                  {/*    defaultValue={active.tabs2}*/}
                  {/*    marks={tabs2.tabs.map((tab, i) => {*/}
                  {/*      let icon = undefined;*/}

                  {/*      return {*/}
                  {/*        value: i,*/}
                  {/*        label: (*/}
                  {/*          <RangeTabLabel*/}
                  {/*            val={i}*/}
                  {/*            tab={active.tabs2}*/}
                  {/*            label={tab.label}*/}
                  {/*            discount={tab.badge}*/}
                  {/*            icon={icon}*/}
                  {/*          />*/}
                  {/*        ),*/}
                  {/*      };*/}
                  {/*    })}*/}
                  {/*    onChange={(e, v) => tabs2.onChange && tabs2.onChange(v as number)}*/}
                  {/*  />*/}
                  {/*</div>*/}
                  {/* <div className="w-full pt-8">
                        <div className="text-dark-3 -mb-4">نوع اتصال:</div>
                        <div className="flex justify-center w-full">
                          <div className="flex flex-col justify-center items-end">
                            {/*<div className="flex flex-col items-end -translate-x-10 gap-2 -mb-2">*/}
                  {/*  <div className="text-blue-1 flex items-center gap-2">*/}
                  {/*    <PlusIcon scale={0.5} />*/}
                  {/*    <span className="text-xl">*/}
                  {/*      {Intl.NumberFormat().format(state.offlinePrice)}*/}
                  {/*    </span>*/}
                  {/*    <span>تومان</span>*/}
                  {/*  </div>*/}
                  {/*  <img src={PointArrow} alt="" className="h-8" />*/}
                  {/*</div>*/}
                  {/* <div className="flex justify-center items-center gap-2">
                              <span>آنلاین</span>
                              <Switch
                                onChange={(val) => {
                                  setState((x) => ({ ...x, offline: val }));
                                  const suggested = subscriptions.find(
                                    (x) =>
                                      x.offline === val &&
                                      x.durationTab === active.tabs2 &&
                                      subscription?.type === x.type
                                  );
                                  if (suggested) {
                                    setActive((x) => ({ ...x, subscription: suggested.id }));
                                  }
                                }}
                              />
                              <div className="flex flex-col items-end">
                                <span>آنلاین + آفلاین</span>
                              </div>
                            </div>
                          </div>
                        </div> 
                      </div> */}
                  {/* </div> */}
                  <div className="flex flex-col gap-8 mt-8 w-full">
                    {/* Plan Cards */}
                    {subscriptions.filter(x => x.offline === false)
                      .map((sub, i) => {
                        if ((durations as any)[sub.duration] !== active.tabs2) return <></>;
                        console.log(subscriptions)
                        const a = sub.id === subscription?.id;
                        console.log(sub.id, a, subscription?.id)
                        return (
                          <Card
                            key={i}
                            branchPrice={state.branchPrice}
                            offLinePrice={state.offlinePrice}
                            subscription={sub}
                            subscriptions={subscriptions}
                            active={a}
                            onChange={(val) => setActive((x) => ({ ...x, subscription: val }))}
                          />
                        );
                      })}
                  </div>
                </div>
                {/* )} */}
                {/* {active.tabs1 === 1 && (
                  <div className="p-2 md:p-4 lg:py-8 lg:px-14">
                    <Main data={data} shopState={data.shopSate} setShopState={data.setShopState} />
                  </div>
                )} */}
              </>
            )}
            {active.topTabs === 1 && (
              <div className="p-2 md:p-4 lg:py-8 lg:px-14">
                <Table {...table} />
              </div>
            )}
          </div>
        </Grid>

        {/* Side */}
        <Grid item md={4} xs={12} className="p-2">
          <StickyBox offsetTop={80} offsetBottom={20}>
            <div id="side-bar" className="bg-white rounded-lg ">
              <Header withDivider>
                <span>اطلاعات سفارش</span>
              </Header>

              {active.tabs1 === 1 ? (
                <Side data={data} shopState={data.shopSate} setShopState={data.setShopState} />
              ) : (
                <div className="flex flex-col gap-8 p-4">
                  {/* Current Plan Section */}
                  <div className="p-4 flex flex-col gap-4">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-1">
                        <BillIcon />
                        <span className="text-dark-3 text-sm ">اشتراک فعلی</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between gap-2">
                      <div className="flex items-center gap-1">
                        <span className="text-sm font-medium">{current.label}</span>
                        {!!current.durationTab && (
                          <span className="text-dark-6 font-medium">
                            {tabs2.tabs[0]?.label}
                          </span>
                        )}
                        <span className="text-dark-1">{current.price}</span>
                      </div>
                      {current.expireDays ? (
                        <div className="flex gap-2">
                          <span className="text-blue-1 font-medium">{diff}</span>
                          <span className="text-dark-5 text-sm">روز مانده</span>
                        </div>
                      ) : (
                        <div className="flex gap-2">
                          <span className="text-red-500 text-sm">منقضی شده</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {subscription && (
                    <>
                      {/* Renewal Plan Section */}
                      <div className="flex flex-col gap-4">
                        <div className="flex gap-1 px-5">
                          <ShopCart color="#1062D0" />
                          <span className="font-medium text-dark-2 ">تمدید اشتراک</span>
                        </div>
                        <div className="flex items-start gap-2 rounded-lg bg-dark-8 p-4">
                          <img src={subscription.icon} alt="" className="w-14" />
                          <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-1 md:gap-2 whitespace-nowrap flex-wrap">
                              <span className="text-lg font-medium">{subscription.label}</span>
                              <span className="text-dark-6 font-medium">
                                {tabs2.tabs[subscription.durationTab]?.label}
                              </span>
                              {/* <span className="text-dark-1">{state.offline ? "(آنلاین + آفلاین)" : ""}</span> */}
                            </div>
                            <div className="flex gap-2">
                              <span className="text-sm text-dark-3">{subscription.currency}</span>
                              <span className="font-medium text-dark-1">
                                {Intl.NumberFormat().format(
                                  //@ts-ignore
                                    subscription.price 



                                )}
                              </span>
                              <span className="text-sm text-dark-3">/</span>
                              <span className="text-sm text-dark-3">12 ماه</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Extra Docs Section */}
                      {/*{!!subscription.accountingLimit && (*/}
                      {/*    <div className="flex justify-between items-center">*/}
                      {/*        <div className="flex p-2">*/}
                      {/*            <span className="font-medium text-dark-6">سند اضافه:</span>*/}
                      {/*        </div>*/}
                      {/*        <div className="flex w-32">*/}
                      {/*            <BasicTextInput*/}
                      {/*                key={subscription.accountingLimit}*/}
                      {/*                type="number"*/}
                      {/*                val={subscription.accountingLimit}*/}
                      {/*                min={subscription.accountingLimit}*/}
                      {/*                onChange={(val) => {*/}
                      {/*                    if (typeof val !== "number") return;*/}
                      {/*                    const limit = subscription.accountingLimit;*/}
                      {/*                    let res = val > limit ? val - limit : 0;*/}
                      {/*                    setState((x) => ({...x, extraDocs: res}));*/}
                      {/*                }}*/}
                      {/*            />*/}
                      {/*        </div>*/}
                      {/*    </div>*/}
                      {/*)} */}
                      {/* Price Section */}
                      <div className="flex flex-col gap-4">
                        <div className="flex justify-between items-center">
                          <span>قیمت اشتراک</span>
                          <div className="flex items-center gap-2">
                            <span className="text-lg font-medium text-dark-5">
                              {Intl.NumberFormat().format(subscription.price)}
                            </span>
                            <span className="text-sm text-dark-3">{subscription.currency}</span>
                          </div>
                        </div>

                        {/*                  <div className="flex justify-between items-center">*/}
                        {/*                      <span>سند اضافه</span>*/}
                        {/*                      <div className="flex items-center gap-2">*/}
                        {/*<span className="text-lg font-medium text-dark-5">*/}
                        {/*  {Intl.NumberFormat().format(state.extraDocs * 1000)}*/}
                        {/*</span>*/}
                        {/*                          <span className="text-sm text-dark-3">{subscription.currency}</span>*/}
                        {/*                      </div>*/}
                        {/*                  </div>*/}

                        <div className="flex justify-between items-center">
                          <span>مالیات بر ارزش افزوده</span>
                          <div className="flex items-center gap-2">
                            <span className="text-lg font-medium text-dark-5">
                              {Intl.NumberFormat().format(subscription.price * (10 / 100))}
                            </span>
                            <span className="text-sm text-dark-3">{subscription.currency}</span>
                          </div>
                        </div>
                      </div>

                      {/* Discount Section */}
                      <div>
                        <BasicButton
                          onClick={() =>
                            setState((x: any) => ({
                              ...x,
                              coupon: { ...x?.coupon, show: !x?.coupon?.show },
                            }))
                          }
                        >
                          {!state?.coupon?.show && <PlusIcon color="#1062D0" scale={0.7} />}
                          {state?.coupon?.show && <MinusIcon color="#1062D0" scale={0.7} />}
                          <span>افزودن کوپن تخفیف</span>
                        </BasicButton>

                        <Collapse in={state?.coupon?.show} className="mt-2">
                          {!state?.coupon?.amount && (
                            <div className="flex flex-col gap-2">
                              <div className="flex justify-between items-end gap-2">
                                <BasicTextInput
                                  label="کد تخفیف را وارد کنید"
                                  max={8}
                                  fullWidth
                                  onChange={(val) =>
                                    setState((x: any) => ({
                                      ...x,
                                      coupon: { ...x?.coupon, code: val },
                                    }))
                                  }
                                  val={state?.coupon?.code}
                                />
                                <BasicButton variant="contained" onClick={() => checkCoupon()}>
                                  {state.coupon.loading && (
                                    <CircularProgress size={14} style={{ color: "#fff" }} />
                                  )}
                                  <span>بررسی</span>
                                </BasicButton>
                              </div>
                              <div className="text-xs text-red-500">{state.coupon.error}</div>
                            </div>
                          )}
                          {!!state?.coupon?.amount && (
                            <div className="flex justify-between px-4">
                              <div className="flex items-center gap-2">
                                <span className="text-dark-4 font-medium">{state.coupon?.label}</span>
                                <IconButton
                                  onClick={() =>
                                    setState((x) => ({
                                      ...x,
                                      coupon: { ...initialCoupon, show: x.coupon.show },
                                    }))
                                  }
                                >
                                  <TrashIcon color="#95A3B5" />
                                </IconButton>
                              </div>
                              <div className="flex items-center gap-2">
                                <span className="text-green-700">
                                  {Intl.NumberFormat().format(state.coupon.amount)}
                                </span>
                                <span className="text-green-400">{state.coupon.currency}</span>
                              </div>
                            </div>
                          )}
                        </Collapse>
                      </div>

                      {/* Final Price section */}
                      <div className="flex flex-col gap-4">
                        <div className="flex justify-between items-center">
                          <span className="font-medium text-dark-6">مبلغ قابل پرداخت</span>
                          <div className="flex items-center gap-2">
                            <span className="text-2xl font-medium text-dark-6">
                              {Intl.NumberFormat().format(
                                subscription.price +
                                subscription.price * (10 / 100) +
                                state.extraDocs * 1000 -
                                (state.coupon?.amount ?? 0)
                              )}
                            </span>
                            <span className="text-sm text-dark-3">{subscription.currency}</span>
                          </div>
                        </div>
                        {/* {!!diff && (
                          <div className="text-dark-3 text-sm">
                            <span>این اشتراک </span>
                            <span className="text-green-600"> {Intl.NumberFormat().format(diff)} تومان </span>
                            <span> به صرفه تر از اشتراک ماهانه است</span>
                          </div>
                        )} */}
                      </div>
                      {/* Button */}
                      <BasicButton variant="contained" className="mt-4" fullWidth onClick={handleSubmit}>
                        <ShopCart color="#fff" />
                        <span>خرید اشتراک</span>
                      </BasicButton>
                    </>
                  )}
                </div>
              )}
            </div>
          </StickyBox>
        </Grid>
      </Grid>
    </Container>
  );
}
